import { render, staticRenderFns } from "./CommandesApproView.vue?vue&type=template&id=16c20e27"
import script from "./CommandesApproView.vue?vue&type=script&lang=js"
export * from "./CommandesApproView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports